<div class="sh-action-bar">
  <div class="sh-action-bar__group" [class.-sh-align-left]="condensed">
    <div class="sh-action-bar__group__item">
      <h5>{{ title }}</h5>
    </div>
    <div class="sh-action-bar__group__item">
      <ng-content></ng-content>
    </div>
  </div>
  @if (!condensed) {
    <div class="sh-action-bar__group">
      @if (sortOptions) {
        <digihaven-sort-info [sortOptions]="sortOptions" (sortInfoChanged)="onSortInfoChange($event)"></digihaven-sort-info>
      }
    </div>
  }
</div>
